/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect, useContext } from 'react';
import Keyboard from 'react-simple-keyboard';
import { useFocusTrap } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import dayjs from 'dayjs';
import OTPInput from 'otp-input-react';
import { useTranslation } from 'react-i18next';
import 'react-simple-keyboard/build/css/index.css';

import { Box, Center, Stack, Title, Modal, Text, Group, Space, Image, Loader } from '@mantine/core';
import { IconX } from '@tabler/icons';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import AlertImg from '../../image/alert.svg';
import PrimaryButton from '../../components/GroupButton';
import AppContext from '../../components/Context/index';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import PaymentStatus from '../PosPayment/PaymentStatus';
import TicketSummary from '../../components/TicketSummary/TicketSummary';
import TimerEvent from '../../components/TimerEvent/TimerEvent';

const UserDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t, i18n } = useTranslation();
  const searchParams = new URLSearchParams(search);
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const [mounted, setMounted] = useState(false);
  const [location, setLocation] = useState('');
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const focusTrapRef = useFocusTrap();
  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  // const onPayment = async () => {
  //   fetch('https://sp.devapi.v2.hyperthings.in/api/v1/payments/checkout', {
  //     method: 'POST',
  //     headers: {
  //       android_id: 'test',
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //     },
  //     body: JSON.stringify({
  //       reservation_id: parseInt(ticketData?.id, 10),
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response?.code === 20) {
  //         navigate({
  //           pathname: '/payment',
  //           search: createSearchParams({
  //             passId: parseInt(ticketData?.id, 10),
  //             checkoutId: response?.data?.id,
  //           }).toString(),
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const [ticketNumber, setTicketNumber] = useState();

  const [ticketData, setTicketData] = useState();
  const [input, setInput] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [numberInput, setNumberInput] = useState('');
  const [charInput, setCharInput] = useState('');
  const [dummyInput, setDummyInput] = useState('');
  const [dummycharInput, setDummyCharInput] = useState('');
  const [updateTicket, setUpdateTicket] = useState();
  const [validPassId, setValidPassId] = useState();

  // const UpdateTicket = () => {
  //   // if (ticketData?.msg === 'Record Found!') {
  //   fetch(`https://sp.devapi.v2.hyperthings.in/api/v1/payments/review-reservation`, {
  //     method: 'POST',
  //     headers: {
  //       android_id: 'test',
  //       'Content-Type': 'application/json',
  //       Accept: 'application/json',
  //     },
  //     body: JSON.stringify({
  //       reservation_id: parseInt(ticketData?.id, 10),
  //       start_time: ticketData?.start_time,
  //       end_time: new Date(),
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((json) => setUpdateTicket(json));
  //   if (updateTicket?.code === 50) {
  //     console.log('up', updateTicket);
  //   }
  //   // }
  // };

  const searchTicket = () => {
    sendRequest(`tickets/${dummyInput + dummycharInput}`, 'get').then((res) => {
      if (res?.data !== null) {
        setTicketData(res?.data || []);
      } else if (res?.data === null) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.numberplate')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });

    // if (ticketData === null) {
    //   showNotification({
    //     title: <Text weight={500}>{t('enter.invalid.numberplate')}</Text>,
    //     icon: <IconX />,
    //   });
    // }

    //   .then((res) => res.json())
    //   .then((json) => setTicketData(json));
    // console.log('mk', ticketData?.number_plate);
    // if (ticketData === null) {
    //   showNotification({
    //     title: <Text weight={500}>{t('enter.invalid.numberplate')}</Text>,
    //     icon: <IconX />,
    //   });
    // }
    // if (ticketData?.msg === 'Record Found!') {
    //   UpdateTicket();
    // }
    setTicketNumber(input);
  };

  useEffect(() => {
    if (ticketData?.pass_id) {
      sendRequest(`parking/site-id-by-pass-id/${ticketData?.pass_id}`, 'get').then((res) => {
        console.log('res', res?.data?.site_id === siteDetails?.siteId);
        if (res?.data?.site_id === siteDetails?.siteId) {
          setValidPassId(ticketData || []);
        } else if (res?.data?.site_id !== siteDetails?.siteId) {
          showNotification({
            title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
            icon: <IconX size={16} />,
          });
        }
      });
    }
  }, [ticketData]);

  // useEffect(() => {
  //   if (ticketData?.msg === 'Record Found!') {
  //     UpdateTicket();
  //   }
  // }, [UpdateTicket, ticketData?.msg]);
  // console.log('mk', ticketData?.id);
  // console.log('mkk', updateTicket);

  const onInputChange = (numberInput) => {
    setDummyInput(numberInput);
  };
  const onCharChange = (charInput) => {
    setDummyCharInput(charInput);
  };
  const InputData = dummyInput + dummycharInput;

  const onChange = () => {
    setInput(InputData);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  // console.log('dsad', ticketData?.msg);

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') searchTicket();
  };

  const onChangeInput = (event) => {
    const data = event.target.value;
    setNumberInput(data);
    keyboard.current.setNumberInput(data);
  };

  const onChangeCharInput = (event) => {
    const data = event.target.value;
    setCharInput(data);
    keyboard.current.setCharInput(data);
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket();
    }
  }, []);

  const posPayment = () => {
    navigate({
      pathname: '/insertcard',
      search: createSearchParams({
        passId: ticketData?.pass_id,
      }).toString(),
    });
  };

  const detailsPage = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        numberplate: ticketData?.number_plate,
        tax: ticketData?.invoices?.tax,
        passId: ticketData?.pass_id,
      }).toString(),
    });
  };

  const now = dayjs();

  const date1 = dayjs(ticketData?.start_time);
  const date2 = dayjs(!ticketData?.end_time ? now : ticketData?.end_time);
  // const diff = date2.diff(date1, 'day', true);
  // console.log('obtained', diff);
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  // console.log(`${days} days, ${hours} hours`);

  const startDate = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(!ticketData?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(!ticketData?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const [response, setResponse] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [cashData, setCashData] = useState();

  const cardPayment = () => {
    if (ticketData?.invoices?.invoice_status?.name === 'paid') {
      setCardPay(true);
    }

    const wsurl = `ws://localhost:5000/messages`;
    // Init Websocket Client
    const client = new W3CWebSocket(wsurl);
    client.onerror = () => {
      console.log('Connection Error');
      if (ticketData?.invoices?.invoice_status?.name === 'paid') {
        setCardPay(true);
      } else {
        setErrorPos(true);
      }
    };

    client.onopen = () => {
      console.log('WebSocket Client Connected');

      function connectPort() {
        if (client.readyState === client.OPEN) {
          const comName = 'COM8';
          const sendData = JSON.stringify({
            Event: 'CONNECTION',
            Operation: 'CONNECT',
            connectionMode: 'COM',
            comName,
            braudRate: '38400',
            dataBits: '8',
            parity: 'none',
          });

          client.send(sendData);
        }
      }

      connectPort();

      function sendAmount() {
        if (client.readyState === client.OPEN) {
          const amount = ticketData?.invoices?.payable_amount;
          const sendAmountData = JSON.stringify({
            Event: 'TRANSACTION',
            Operation: 'PURCHASE',
            Amount: amount,
            PrintSettings: '1',
            AppId: '11',
            ECRNumber: '1234567890123456',
          });
          client.send(sendAmountData);
        }
      }
      sendAmount();
    };

    client.onclose = () => {
      console.log('echo-protocol Client Closed');
    };

    client.onmessage = (message) => {
      if (typeof message.data === 'string') {
        // console.log('Received', message.data);
        setResponse(JSON.parse(message?.data));
      }
    };
  };
  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    } else if (response?.TerminalStatus === 'BUSY') {
      setCardPay(true);
    }
    console.log('adsa');
  }, []);
  console.log('payment-status', paymentStatus);
  // console.log('push-resID&transactionId to backend', body, data);
  useEffect(() => {
    if (response?.EventName === 'TERMINAL_RESPONSE') {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequestWithToken(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setCardPay(false);
            navigate({
              pathname: '/qrScanner',
              search: createSearchParams({
                passId: ticketData?.pass_id,
              }).toString(),
            });
            console.log('payment-status', paymentStatus);
            console.log('push-resID&transactionId to backend', body, data);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err?.response?.data?.code) {
            console.log('err', err?.response?.data?.code);
          }
        });
    }
  }, [
    paymentStatus,
    paymentStatus?.RetrievalReferenceNumber,
    response?.EventName,
    searchTicket,
    ticketData?.result?.id,
  ]);
  return (
    <Box>
      {validPassId?.pass_id ? <TimerEvent /> : null}
      <Center className="no-printme">
        {!validPassId?.pass_id ? (
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('enter.car.numberplate')}
          </Title>
        ) : (
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('enter.ticket.summary')}
          </Title>
        )}
      </Center>
      <Space h="md" />
      <Center className="no-printme">
        <Stack>
          <Center>
            {/* <Input placeholder="Ticket Number" width="100%" onChange={searchTicket} p="xl" /> */}
            {/* <Input
                placeholder="Ticket Number"
                sx={{ width: '100%' }}
                value={input}
                onChange={onChangeInput}
                disabled={ticketData?.id}
                px="xl"
                size="md"
              /> */}
            {!validPassId?.pass_id ? (
              <>
                <OTPInput
                  OTPLength={4}
                  // placeholder="1234"
                  inputStyles={{
                    width: '60px',
                    height: '50px',
                    fontSize: '2.5rem',
                  }}
                  value={dummyInput}
                  onChange={onChangeInput}
                  disabled={ticketData?.id}
                />
                <Space w="xl" />
                <Space w="xl" />

                <OTPInput
                  OTPLength={3}
                  // placeholder="ABC"
                  inputStyles={{
                    width: '60px',
                    height: '50px',
                    fontSize: '2.5rem',
                  }}
                  value={dummycharInput}
                  onChange={onChangeCharInput}
                  disabled={ticketData?.id}
                />
              </>
            ) : null}
          </Center>
          {/* {!ticketData?.id && ticketNumber !== ticketData?.id ? (
            <Center>
              <Title order={3}>{t('enter.invalid.numberplate')}</Title>
            </Center>
          ) : null} */}
          {validPassId?.pass_id ? (
            // <Container>
            //   <Paper shadow="lg" withBorder p="xl">
            //     <Stack>
            //       <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
            //         <Text size="sm" weight={500} color="#817E7E">
            //           {t('ticket.welcome')} {t('ticket.guest')}
            //         </Text>
            //         {ticketData?.invoices?.invoice_status?.name === 'paid' ? (
            //           <Text size="xl" weight={700} color="green">
            //             {t('status.paid')}
            //           </Text>
            //         ) : null}

            //         <Text size="sm" weight={500} color="#817E7E">
            //           {t('ticket.plate.number')} : {ticketData?.number_plate}
            //         </Text>
            //       </Group>

            //       <Group position="apart" style={{ marginBottom: '-20px' }}>
            //         <Group>
            //           <Stack>
            //             <Center>
            //               <Title size="sm" order={2}>
            //                 {t('ticket.entry.text')}
            //               </Title>
            //             </Center>
            //             <Center style={{ marginBottom: '-18px' }}>
            //               <Text size="sm" weight={500}>
            //                 {startDate}
            //               </Text>
            //             </Center>
            //             <Center>
            //               <Text size="sm" weight={500}>
            //                 {startTime}
            //               </Text>
            //             </Center>
            //           </Stack>
            //         </Group>
            //         {appState?.language === 'ar' ? (
            //           <Image src={CarArrowReverse} />
            //         ) : (
            //           <Image src={CarArrow} />
            //         )}
            //         <Group>
            //           <Stack>
            //             <Center>
            //               <Title size="sm" order={2}>
            //                 {t('ticket.exit.text')}
            //               </Title>
            //             </Center>
            //             <Center style={{ marginBottom: '-18px' }}>
            //               <Text size="sm" weight={500}>
            //                 {endDate}
            //               </Text>
            //             </Center>
            //             <Center>
            //               <Text size="sm" weight={500}>
            //                 {endTime}
            //               </Text>
            //             </Center>
            //           </Stack>
            //           <ActionIcon
            //             color="dark"
            //             size="xl"
            //             radius="xl"
            //             variant="default"
            //             sx={{
            //               borderColor: 'black',
            //               width: '80px',
            //               height: '80px',
            //               borderRadius: '50px',
            //             }}
            //           >
            //             <Text weight={900} size="lg">
            //               {hours} {t('ticket.hours.text')}
            //             </Text>
            //           </ActionIcon>
            //         </Group>
            //       </Group>
            //       <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
            //         <Stack>
            //           <Title size="sm" order={2}>
            //             {t('ticket.description.text')}
            //           </Title>
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {hours} {t('ticket.hours.parking.text')}
            //           </Text>

            //           {/* {ticketData?.vas_orders.map((item) => (
            //             <Text size="sm" weight={500} color="#817E7E">
            //               {item?.vas_types?.name}
            //             </Text>
            //           ))} */}
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {t('ticket.tax.text')}
            //           </Text>
            //         </Stack>
            //         <Space w="xl" />
            //         <Space w="xl" />
            //         <Space w="xl" />
            //         <Stack spacing="xl">
            //           <Title size="sm" order={2}>
            //             {t('ticket.amount.text')}
            //           </Title>
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {ticketData?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.invoices?.total_amount}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Text>

            //           {/* {ticketData?.vas_orders.map((item) => (
            //             <Text size="sm" weight={500} color="#817E7E">
            //               {item?.amount} SAR
            //             </Text>
            //           ))} */}
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {ticketData?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.invoices?.tax}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Text>
            //         </Stack>
            //       </Group>
            //       <Divider size="sm" />
            //       <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
            //         <Title size="sm" order={2}>
            //           {t('ticket.amount.total.text')}
            //         </Title>
            //         <Title size="sm" order={2}>
            //           {ticketData?.invoices?.payable_amount} {t('ticket.amount.sar.text')}
            //         </Title>
            //       </Group>

            //       <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
            //         <SimpleGrid cols={2} sx={{ width: '100%' }}>
            //           {ticketData?.invoices?.invoice_status?.name === 'paid' ? (
            //             <Button
            //               // onClick={posPayment}
            //               onClick={cardPayment}
            //               sx={{ backgroundColor: '#01AA84', width: '100%' }}
            //               size="xl"
            //               // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
            //             >
            //               {t('payment.status.invoice.print.invoice.button.text')}
            //             </Button>
            //           ) : (
            //             <Button
            //               // onClick={posPayment}
            //               onClick={cardPayment}
            //               sx={{ backgroundColor: '#01AA84', width: '100%' }}
            //               size="xl"
            //               // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
            //             >
            //               {t('ticket.amount.pay.button.text')}
            //             </Button>
            //           )}
            //           <Button
            //             onClick={detailsPage}
            //             sx={{ backgroundColor: '#34B3F1', width: '100%' }}
            //             size="xl"
            //           >
            //             {t('ticket.amount.other.service.button.text')}
            //           </Button>
            //         </SimpleGrid>
            //       </Group>
            //     </Stack>
            //   </Paper>
            // </Container>
            <TicketSummary passId={validPassId?.pass_id} />
          ) : null}
        </Stack>
      </Center>

      <Space w="md" />
      <Space w="xl" />
      <Space w="xl" />
      {!validPassId?.pass_id ? (
        <>
          <Group position="apart" px="xl">
            <Box py="xl" style={{ width: '300px' }}>
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onChange={onInputChange}
                onKeyPress={onKeyPress}
                maxLength={4}
                layoutName={layout}
                layout={{
                  default: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                  shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': 'Enter',
                }}
              />
            </Box>
            <Box py="xl" style={{ width: '300px' }}>
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onChange={onCharChange}
                onKeyPress={onKeyPress}
                layoutName={layout}
                maxLength={3}
                layout={{
                  default: ['A B J D', 'R S X T', 'E G K L', 'Z N H U', '{shift} V {bksp}'],
                  shift: ['ن ه و ي', 'ق ك ل م', 'س ص ط ع', 'ب ح د ر', '{shift} أ {bksp}'],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': shiftButtonText !== 'Arabic' ? 'إرسال' : 'Enter',
                  '{shift}': shiftButtonText !== 'Arabic' ? 'ENG' : 'عربي',
                }}
              />
            </Box>
          </Group>
          <Center>
            <Box py="xl" style={{ width: '300px' }}>
              <Keyboard
                // eslint-disable-next-line no-return-assign
                keyboardRef={(r) => (keyboard.current = r)}
                onChange={onChange}
                onKeyPress={onKeyPress}
                layoutName={layout}
                layout={{
                  default: ['{enter}'],
                  shift: ['{enter}'],
                }}
                display={{
                  '{enter}': appState?.language === 'ar' ? 'إرسال' : 'Enter',
                }}
              />
            </Box>
          </Center>
        </>
      ) : null}
      <Space h="xs" />

      {!ticketData?.id ? (
        <>
          <Space h="xl" />
          <Space h="xl" />
          <Space h="md" />
        </>
      ) : null}
      <PrimaryButton />
      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
      <Modal
        opened={cardPay}
        onClose={() => setCardPay(false)}
        centered
        size="90%"
        // title={<Text p="xl">You want to end the shift</Text>}
      >
        <Center>
          {paymentStatus?.TransactionResponseEnglish === 'APPROVED' ||
          ticketData?.invoices?.invoice_status?.name === 'paid' ? (
            <PaymentStatus
              invoiceDataId={ticketData?.invoices?.id}
              passDataId={ticketData?.passId}
            />
          ) : (
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {response?.TerminalStatus === 'BUSY' ? (
                        <Stack>
                          <Title order={1}>Payment Processing</Title>
                          <Loader variant="dots" />
                        </Stack>
                      ) : paymentStatus?.TransactionResponseEnglish === 'DECLINED' ? (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </Center>
          )}
        </Center>
      </Modal>
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
    </Box>
  );
};

export default UserDetails;
